import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, BASE_URL } from '../api/client';
import { getThunkName, showThunkName, createThunkName, updateThunkName, deleteThunkName } from './base';

export const thunkPerformanceAchievementApprovalApi = 'api/approval-capaian-perkin';
export const slicePerformanceAchievementApprovalName = 'approval-capaian-perkin';

// Sasaran
export const getPerformanceAchievementApproval = createAsyncThunk(getThunkName(thunkPerformanceAchievementApprovalApi), async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApprovalApi + '?' + params, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const showPerformanceAchievementApproval = createAsyncThunk(showThunkName(thunkPerformanceAchievementApprovalApi), async (id, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApprovalApi + '/' + id, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updatePerformanceAchievementApproval = createAsyncThunk(updateThunkName(thunkPerformanceAchievementApprovalApi), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await client.put(BASE_URL + thunkPerformanceAchievementApprovalApi + '/' + id + '/approval', body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceAchievementApprovalSlice = createSlice({
  name: slicePerformanceAchievementApprovalName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    show: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    update: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPerformanceAchievementApproval.pending, state => {
        state.get.data = [];
        state.get.status = 'loading';
        state.get.message = '';
        state.get.error = '';
        state.get.pagination = {};
      })
      .addCase(getPerformanceAchievementApproval.fulfilled, (state, action) => {
        state.get.data = action.payload.data;
        state.get.status = 'succeeded';
        state.get.message = action.payload.message;
        state.get.error = '';
        state.get.pagination = action.payload.meta;
      })
      .addCase(getPerformanceAchievementApproval.rejected, (state, action) => {
        state.get.data = [];
        state.get.status = 'failed';
        state.get.message = action.payload.message;
        state.get.error = action.payload.error;
        state.get.pagination = {};
      })
      .addCase(updatePerformanceAchievementApproval.pending, state => {
        state.update.data = {};
        state.update.status = 'loading';
        state.update.message = '';
        state.update.error = '';
      })
      .addCase(updatePerformanceAchievementApproval.fulfilled, (state, action) => {
        state.update.data = action.payload.data;
        state.update.status = 'succeeded';
        state.update.message = action.payload.message;
        state.update.error = '';
      })
      .addCase(updatePerformanceAchievementApproval.rejected, (state, action) => {
        state.update.data = {};
        state.update.status = 'failed';
        state.update.message = action.payload.message;
        state.update.error = action.payload.error;
      })
      .addCase(showPerformanceAchievementApproval.pending, (state, action) => {
        state.show.data = {};
        state.show.status = 'loading';
        state.show.message = '';
        state.show.error = '';
      })
      .addCase(showPerformanceAchievementApproval.fulfilled, (state, action) => {
        state.show.data = action.payload.data;
        state.show.status = 'succeeded';
        state.show.message = action.payload.message;
        state.show.error = '';
      })
      .addCase(showPerformanceAchievementApproval.rejected, (state, action) => {
        state.show.data = {};
        state.show.status = 'failed';
        state.show.message = action.payload.message;
        state.show.error = action.payload.error;
      })
  },
});

export default PerformanceAchievementApprovalSlice.reducer;
